import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	new: {
		id: 'business-onboarding-board-saved-views.new',
		defaultMessage: 'New',
		description: '"New" lozenge shown to a user when new UI elements are released.',
	},
});
